// import * as tokens from '@cloudscape-design/design-tokens';
import * as tokens from '@amzn/awsui-design-tokens';

export const tagStyles = {
    root: {
        background: "#e8f4fd",
        color: "#0073bb",
        borderRadius: "10px",
        borderWidth: "0px",
        paddingBlock: "2px",
        paddingInline: "8px",
        fontSize: "12px",
    }
};

export const greenButtonStyles = {
    root: {
        background: {
            active: tokens.colorChartsGreen600,
            default: tokens.colorChartsGreen700,
            hover: tokens.colorChartsGreen800
        },
        color: {
            active: tokens.colorTextSegmentActive,
            default: tokens.colorTextSegmentActive,
            hover: tokens.colorBackgroundCellShaded
        },
        borderWidth: "0px"
    }
};

export const greyButtonStyles = {
    root: {
        background: {
            default: tokens.colorBackgroundNotificationGrey,
            hover: tokens.colorBackgroundNotificationGrey
        },
        color: {
            default: tokens.colorTextSegmentActive,
            hover: tokens.colorBackgroundCellShaded
        },
        borderWidth: "0px"
    }
};

export const orangeButtonStyles = {
    root: {
        background: {
            active: tokens.colorChartsGreen600,
            default: tokens.colorChartsGreen700,
            hover: tokens.colorChartsGreen800
        },
        color: {
            active: tokens.colorBackgroundButtonPrimaryActive,
            default: tokens.colorBackgroundButtonPrimaryDefault,
            hover: tokens.colorBackgroundButtonPrimaryDefault
        },
        borderWidth: "0px",
    }
};

export const badgeStyles = {
    root: {
        borderWidth: "0px",
        borderRadius: tokens.borderRadiusBadge,
        background: tokens.colorBackgroundNotificationBlue
    }
};

export const buttonSizingStyles = {
    root: {
        background: {
            active: tokens.colorChartsGreen600,
            default: tokens.colorChartsGreen700,
            hover: tokens.colorChartsGreen800
        },
        color: {
            active: tokens.colorTextSegmentActive,
            default: tokens.colorTextSegmentActive,
            hover: tokens.colorBackgroundCellShaded
        },
        borderWidth: "0px"
    }
};

export const removeIconStyles = {
    root: {
        color: {
            default: tokens.colorBackgroundNotificationRed,
            active: tokens.colorBackgroundNotificationSeverityHigh,
            hover: tokens.colorBackgroundNotificationSeverityHigh
        },
        background: {
            active: "#fce9e6",
            hover: "#fce9e6"
        },
        borderWidth: "0px",
        borderRadius: tokens.borderRadiusButton,
        paddingBlock: "4px",
        paddingInline: "6px"
    }
};

export const editIconStyles = {
    root: {
        color: {
            default: tokens.colorBackgroundNotificationGrey,
            active: "#161d26",
            hover: "#161d26"
        },
        background: {
            active: tokens.colorBackgroundCellShaded,
            hover: tokens.colorBackgroundCellShaded
        },
        borderWidth: "0px",
        borderRadius: tokens.borderRadiusButton,
        paddingBlock: "4px",
        paddingInline: "6px"
    }
};

export const TabsStyles = {
    tab: {
        color: {
            default: 'light-dark(rgb(71, 85, 105), rgb(148, 163, 184))',
            hover: 'light-dark(rgb(51, 65, 85), rgb(203, 213, 225))',
            active: 'light-dark(rgb(22, 29, 38), rgb(255, 255, 255))',
            disabled: 'light-dark(rgb(148, 163, 184), rgb(71, 85, 105))',
        },
        fontSize: tokens.fontSizeBodyM,
        fontWeight: tokens.fontWeightBold,
        activeIndicator: {
            color: tokens.colorChartsGreen600 //'#ff9900'
        },
    }
}

export const passdownHistoryStyles = {
    content: {
        paddingBlock: '12px',
        paddingInline: '10px',
    },
    
};

